import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertToDateObject',
})
export class ConvertToDateObjectPipe implements PipeTransform {
  transform(date: string | number) {
    return new Date(date);
  }
}
